/**************************************************
 * Nombre:       TarjetaProducto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import marco from '../../Recursos/fondo_empanandas.svg'
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useProductosCarrito} from "../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {useEffect} from "react";


const TarjetaProducto = ({item}) => {
    const {productos, agregarProducto, estaProducto, obtenerProducto} = useProductosCarrito()


    useEffect(() => {
        obtenerProducto();
    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 9}}
                  sx={{justifyContent: 'center', mb: item && item.img ? -10 : 12}}>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        maskImage: `url(${marco})`,
                        maskRepeat: 'no-repeat',
                        maskSize: '100%',
                        //   maskBorder: 'alpha',
                        //  maskBorderWidth: 10,

                    }}>


                    <img src={item.img} width={'100%'} height={'auto'}/>

                </Grid>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    border: 4,
                    borderColor: '#000',
                    borderRadius: 4,
                    px: 2,
                    py: 4,
                    color: '#fff'
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 20, textAlign: 'center', lineHeight: 1.1}}>
                        {item.nombre}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{
                        fontSize: 14, textAlign: 'center', lineHeight: 1.1, display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 3,
                        height: 50
                    }}>
                        {item.descripcion}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{fontSize: 20, textAlign: 'center', lineHeight: 1.1, fontWeight: 800}}>
                        {formatoMoneda(item.valor)}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                    <Button
                        onClick={() => agregarProducto(item)}
                        color={"secondary"} sx={{color: theme.palette.primary.main, fontSize: 14, fontWeight: 400}}>
                        {obtenerProducto(item.id) ? `${obtenerProducto(item.id).cantidad} Agregados` : 'Agregar al carrito'}
                    </Button>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default TarjetaProducto    